import { DestinationAdGroup } from '@app/client/criterion-addition/shared/models/destination.models';
import {
  AdgroupStatus,
  AdPlatform,
  CampaignOptimizationSupport,
  CampaignOptimizationValue,
  CampaignType,
  CompositeId,
  GoalType,
} from '@app/core/models/common.models';
import { Currency } from '@app/core/models/customer.models';
import { PerformanceGroupGoal } from '@app/core/models/pg-goal.model';

export enum ProductAdSyncMode {
  AddMissing = 'ADD-MISSING',
  Overwrite = 'OVERWRITE',
}

export enum AllProductAdSyncMode {
  KeepCurrentSource = 'KEEP-CURRENT-SOURCE',
  AddMissing = 'ADD-MISSING',
  Overwrite = 'OVERWRITE',
  DisableSync = 'DISABLE-SYNC',
}

export interface ProductAdSyncAdGroupTarget extends DestinationAdGroup {
  syncMode: AllProductAdSyncMode;
  readOnly: boolean;
}

export interface ProductAdSyncTarget {
  adspertAccountId: number;
  accountId: string;
  accountName: string;
  accountPlatform: AdPlatform;
  accountOptimize: boolean;
  accountCurrency: Currency;
  accountIsDemo: boolean;
  accountTagsUser: string[];
  adspertAdgroupId: CompositeId;
  adgroupId: number;
  adgroupName: string;
  adgroupStatus: AdgroupStatus;
  adgroupLabels: string[];
  adspertCampaignId: CompositeId;
  campaignId: number;
  campaignName: string;
  campaignType: CampaignType;
  campaignOptimize: boolean;
  campaignLabels: string[];
  campaignOptimizationType: CampaignOptimizationValue;
  campaignOptimizationSupport: CampaignOptimizationSupport;
  campaignEbyMarketplaceId: string;
  performanceGroupId: number;
  performanceGroupName: string;
  performanceGroupOptimizationType: CampaignOptimizationValue;
  performanceGroupEnabled: boolean;
  performanceGroupGoals: PerformanceGroupGoal[];
  performanceGroupGoalTypes: GoalType[];
  adspertPortfolioId: CompositeId;
  amzPortfolioId: number;
  amzPortfolioName: string;
  targets: ProductAdSyncAdGroupTarget[];
}

export interface ProductAdSyncSaveTarget {
  sourceAdspertAdgroupId: CompositeId;
  targetAdspertAdgroupId: CompositeId;
  syncMode: ProductAdSyncMode | AllProductAdSyncMode;
}
